import { Request } from '~src/httpClient/serverApi/requests/Request';

import { ISiteTrial, TrialType } from '../../types/ISiteTrial';

export interface IActivateTrialParams {
  trialType: TrialType;
}

export interface IActivateTrialResult {
  trial: ISiteTrial;
}

export class ActivateTrialRequest extends Request<IActivateTrialParams, IActivateTrialResult> {
  constructor(params: IActivateTrialParams) {
    super('activateTrial', params);
  }
}
